/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from "react";
import { Box, ListItemAvatar, ListItemText, ListItem } from "@mui/material";

import useStyles from "./styles";

export interface SearchListItemProps {
  /**
   * Optional: Custom className can be passed which will on the root node of listitem. This classname can be used as a reference of making any custom styling changes.
   */
  className?: string;
  /**
   * Optional: prop to enable wrapping of secondary content and show in 2 lines.
   */
  wrapText?: boolean;
  /**
   * Required: prop to enable/Show the listItem for specific view. E.g if the design has icon or avatar
   */
  showAvatarContent?: boolean;
  /**
   * Optional: func. prop to return content over the primary section.
   */
  ListOverlineContent?: React.ReactNode;
  /**
   * Optional: func. prop to return avatar content. If Avatar needs to be shown in the every listItem
   */
  ListAvatarContent?: React.ReactNode;
  /**
   * Optional: func. prop to return Primary content.
   */
  ListPrimaryContent?: React.ReactNode;
  /**
   * Optional: func. prop to return Secondary content below the primary content.
   */
  ListSecondaryContent?: React.ReactNode;
  /**
   * Optional: func. prop to return Secondary Action content on the right corner of list item.
   */
  ListSecondaryActionContent?: React.ReactNode;
}

export const SearchListItem: React.FC<SearchListItemProps> = (props) => {
  const classes = useStyles();
  const {
    showAvatarContent,
    ListAvatarContent,
    ListPrimaryContent,
    ListSecondaryContent,
    ListSecondaryActionContent,
  } = props;
  return (
    <ListItem
      secondaryAction={ListSecondaryActionContent}
      className={classes.listItem}
    >
      {showAvatarContent && (
        <ListItemAvatar className={classes.avatarWrapper}>
          <Box className={classes.avatarDisplay}>{ListAvatarContent}</Box>
        </ListItemAvatar>
      )}
      <ListItemText
        disableTypography={true}
        secondary={ListSecondaryContent}
        inset={!Boolean(showAvatarContent)}
        className={classes.listItem}
      >
        {ListPrimaryContent}
      </ListItemText>
    </ListItem>
  );
};

export default SearchListItem;
